import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonContent } from '@ionic/angular';

@Component({
  selector: 'app-offers',
  templateUrl: 'offers.html',
  styleUrls: ['offers.scss']
})
export class OffersPage {
  @ViewChild(IonContent) contentt: IonContent;

  public content = false;
  public content2 = false;
  public content3 = false;

  constructor(private router: Router) { }

  ionViewDidEnter() {
    const jan1 = new Date(2018, 0, 1);
    const currentDate = new Date();

    if (jan1 < currentDate) {
      this.router.navigate(['']);
    }
  }

  open(url) {
    window.open(url, '_blank');
  }

  hideText() {
    const date = new Date();
    const maxDate = new Date('Sun Dec 31 2017 00:00:00');
    if (date < maxDate) {
      return true;
    } else {
      return false;
    }
  }
}
